import { createAction } from 'redux-actions'

const ENTITY = 'ACCORDION_PAGINATION'
export const stateKey = 'accordionPagination'

export const setAccordionPage = createAction(`${ENTITY}/SET_PAGE`, (domain, page) => ({ domain, page }))
